





























import { Prop, Component, Vue, Emit } from 'vue-property-decorator';
import type { IField, IMergeValues, Form, EBlockWidth } from '@getaccept/editor-lib';
import { EContext, FieldInputType } from '@getaccept/editor-lib';
import type { IRecipient } from '@lib-shared/types/Recipient';
import type { IUser } from '@lib-shared/users/types/user';
import type { IEditorRecipientInput } from '@lib-shared/types/editor-recipient-input';
import InputSet from './InputSet.vue';

@Component({
  components: {
    InputSet,
  },
  data: () => ({
    FieldInputType,
  }),
})
export default class EditorNodeForm extends Vue {
  @Prop({ default: () => EContext.Document }) context: EContext;
  @Prop() node: Form;
  @Prop() mergeValues: IMergeValues;
  @Prop() isMobile: boolean;
  @Prop() blockWidthClass: EBlockWidth;
  @Prop() focusedRequiredId?: string;
  @Prop() isSigningSite: boolean;
  @Prop() sender: IUser;
  @Prop() recipient: IRecipient;
  @Prop() recipientInput!: IEditorRecipientInput[];
  @Prop() isPdfViewer: boolean;
  @Prop() updatingInputs!: IEditorRecipientInput[];
  @Prop() failedInputUpdates!: IEditorRecipientInput[];

  @Emit('update-input-value') updateInputValue(id: string, value: string) {
    return { id, value };
  }

  get inputSets(): IField[][] {
    return this.node.inputFieldSets.map(inputSet => inputSet.ids.map(this.getFieldById));
  }

  getFieldById(id: string): IField {
    return this.node.fields.find(field => field.id === id);
  }
}
